import regRule from '@/app-shared/utils/reg-rule.js';
import { escapeHtml } from '@/app-shared/utils/tool';
import { getBrowserType } from '@/app-shared/utils/getBrowserType.js';

/**
 * 超链接识别
 * @param {string} 要处理的字符串
 * @param {string}
 * @returns
 */

/**
 * 超链接识别
 * @param {string} str 要处理的字符串
 * @param {object} options aClassNameStr a标签的 classname; isEscapeHtml 是否转译字符串
 * @returns 结果字符串
 */
export function urlToLink(str, options) {
  let isEscapeHtml, aClassNameStr, needXss;

  if (options) {
    isEscapeHtml = options?.isEscapeHtml;
    aClassNameStr = options?.aClassNameStr;
    needXss = options?.needXss;
    return strHandler;
  }

  if (!str) return '';

  return strHandler(str);

  function strHandler(str) {
    if (needXss) {
      str = doXss(str);
    }
    if (isEscapeHtml) {
      str = escapeHtml(str);
    }
    // console.error(str);
    // if (!str) {
    //   return;
    // }
    // 提取聊天内容中的 img 标签
    const regImg = regRule.img;
    const imgArr = str?.match(regImg);

    // 提取聊天内容中除去 img 标签以外的部分
    const strArr = str?.split(regImg);
    // eslint-disable-next-line no-useless-escape
    const regUrl = regRule.url;

    // 将聊天内容中除去 img 标签以外的聊天内容中的链接用 a 标签包裹
    strArr &&
      strArr.forEach((item, index) => {
        const tempStr = item.replace(regUrl, function (match) {
          /* prettier-ignore */
          return `<a class="${aClassNameStr || 'vh-link vh-link--primary'}"  href='${match}' target='_blank'>${match}</a>`;
        });
        strArr[index] = tempStr;
      });

    // 遍历 img 标签数组，将聊天内容中的 img 标签插回原来的位置
    if (imgArr) {
      const imgArrLength = imgArr.length;
      let imgIndex = 0;
      for (let strIndex = 0; strIndex < imgArrLength; ++strIndex) {
        strArr.splice(strIndex + imgIndex + 1, 0, imgArr[imgIndex]);
        imgIndex++;
      }
    }
    return strArr?.join('');
  }
}
//隐藏favicon图标
export function hideFavicon() {
  var link = document.createElement('link');
  link.setAttribute('rel', 'icon');
  link.setAttribute('href', 'data:;base64,=');
  document.getElementsByTagName('head')[0].appendChild(link);
}
//移除骨架图
export function removeSkeletons() {
  document.getElementById('skeleton')?.remove();
}
export const openHref = href => {
  try {
    window.parent !== window &&
      window.parent.postMessage(
        {
          type: 'openHref',
          data: href
        },
        '*'
      );
    window.top !== window &&
      window.top.postMessage(
        {
          type: 'vhOpenHref',
          data: href
        },
        '*'
      );
    // 非嵌入页面，直接跳转链接
    if (window.self === window.top) {
      const { system } = getBrowserType();
      if ('ios' === system) {
        console.log('当前是手机端打开-ios');
        window.location.href = href;
      } else {
        console.log('当前是手机端打开-其它');
        window.open(href);
      }
    }
  } catch (error) {
    console.log('openHref---', href);
  }
};

/**
 * 通知父级：子页面内容当前宽、高度
 * @param option
 */
export function vhPageStylePostMessage(option = {}) {
  console.log('vhPageStylePostMessage...');
  const data = {
    scrollWidth: document.body.scrollWidth,
    scrollHeight: document.body.scrollHeight,
    innerHeight: window.innerHeight,
    innerWidth: window.innerWidth,
    clientHeight: document.body.clientHeight,
    clientWidth: document.body.clientWidth,
    offsetHeight: document.body.offsetHeight,
    offsetWidth: document.body.offsetWidth,
    ...option
  };
  window.top !== window &&
    window.top.postMessage(
      {
        type: 'vhPageStyle',
        data
      },
      '*'
    );
}

/**
 * 通知父级：处理登录（调用第三方登录）
 * @param option
 */
export function vhThirdLoginPostMessage(option = {}) {
  console.log('vhThirdLoginPostMessage...');
  let opt = {};
  window.top !== window &&
    window.top.postMessage(
      {
        type: 'vhThirdLogin',
        data: {
          ...opt,
          business_id: sessionStorage.getItem('initGrayId')
        }
      },
      '*'
    );
}

//是否被iframe嵌套
export const inIframe = window.self !== window.top;

// /**
//  * 通知父级：当前已展示底部立即预约、立即观看按钮
//  * 仅供 单场大会meeting 移动端 适配h3c页脚背景使用
//  * @param option
//  */
// export function vhLiveBottomBtnShowPostMessage(option = {}) {
//   console.log('vhLiveBottomBtnShowPostMessage...');
//   let opt = {};
//   window.postMessage(
//     {
//       type: 'vhLiveBottomBtnShow',
//       data: {
//         ...opt,
//         business_id: sessionStorage.getItem('initGrayId')
//       }
//     },
//     '*'
//   );
// }

/**
 * 通知父级：处理微信订阅通知
 * 展示 服务号订阅通知按钮
 * @param option
 * @reference https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/Wechat_Open_Tag.html#%E6%9C%8D%E5%8A%A1%E5%8F%B7%E8%AE%A2%E9%98%85%E9%80%9A%E7%9F%A5%E6%8C%89%E9%92%AE%EF%BC%9Awx-open-subscribe
 */
export function vhWXOpenSubscribePostMessage(option = {}) {
  if (inIframe) {
    let data = {
      type: 'vhWXOpenSubscribe',
      data: {
        ...option,
        business_id: sessionStorage.getItem('initGrayId')
      }
    };
    console.log('[message pipeline] vhWXOpenSubscribePostMessage ', data);
    window.top.postMessage(data, '*');
  }
}

/**
 * 通知父级：当前直播间未报名
 * @param option
 */
export function vhNotSignedUpPostMessage(option = {}) {
  if (inIframe) {
    let data = {
      type: 'vhNotSignedUp',
      data: {
        ...option,
        business_id: sessionStorage.getItem('initGrayId')
      }
    };
    console.log('[message pipeline] vhNotSignedUpPostMessage ', data);
    window.top.postMessage(data, '*');
  }
}

/**
 * 通知父级：处理报名流程
 * @param option
 */
export function vhSignUpPostMessage(option = {}) {
  if (inIframe) {
    let data = {
      type: 'vhSignUp',
      data: {
        ...option,
        business_id: sessionStorage.getItem('initGrayId')
      }
    };
    console.log('[message pipeline] vhSignUpPostMessage ', data);
    window.top.postMessage(data, '*');
  }
}

/**
 * 通知父级：当前播放器事件
 * @param option
 */
export function vhPlayerSdkEventMessage(option = {}) {
  if (inIframe) {
    let data = {
      type: 'vhPlayerSdkEvent',
      data: {
        ...option,
        business_id: sessionStorage.getItem('initGrayId')
      }
    };
    console.log('[message pipeline] vhPlayerSdkEventMessage ', data);
    window.top.postMessage(data, '*');
  }
}

/**
 * 通知父级：直播间状态变更
 * @param option
 */
export function vhWebinarTypeChangePostMessage(option = {}) {
  if (inIframe) {
    let data = {
      type: 'vhWebinarTypeChange',
      data: {
        ...option,
        business_id: sessionStorage.getItem('initGrayId')
      }
    };
    console.log('[message pipeline] vhWebinarTypeChangePostMessage ', data);
    window.top.postMessage(data, '*');
  }
}

// 对外消息枚举值
export const DEP_TYPE_NUM = {
  webinar: 1, // 直播间
  page: 4, // 单场大会
  series: 5, // 系列会
  website: 6 // 聚合主站
};

export const DEP_TYPE_STR = {
  1: 'webinar', // 直播间
  4: 'page', // 单场大会
  5: 'series', // 系列会
  6: 'website' // 聚合主站
};

export function doXss(str) {
  if (str) {
    return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
  } else {
    return str;
  }
}

/**
 * 通知父级，刷新当前页面
 * @param option
 */
export function vhReloadLivePagePostMessage(option = {}) {
  if (inIframe) {
    let data = {
      type: 'vhReloadLivePage',
      data: {
        ...option,
        business_id: sessionStorage.getItem('initGrayId')
      }
    };
    console.log('[message pipeline] vhReloadLivePagePostMessage ', data);
    if (window.top !== window.parent) {
      window.parent.postMessage(data, '*');
    }
    window.top.postMessage(data, '*');
  }
}

/**
 * 通知父级：展示预售商品弹框
 * @param option
 */
export function vhShowPreSaleGoodsDialogPostMessage(option = {}) {
  if (inIframe) {
    let data = {
      type: 'vhShowPreSaleGoodsDialog',
      data: {
        ...option,
        business_id: sessionStorage.getItem('initGrayId')
      }
    };
    console.log('[message pipeline] vhShowPreSaleGoodsDialogPostMessage ', data);
    window.top.postMessage(data, '*');
  }
}

/**
 * 通知父级：当前站点基础信息
 * 业务场景：
 *  全局嵌入页，
 *    父级设置浏览器标题
 *    父级微信分享
 *
 * @example
 * {
 *   business_id: '',//B租户ID
 *   site_id: '',//站点id
 *   site_type: '',//站点类型  1：单场大会 2: 系列会 3: 聚合站点 4: 网络研讨会
 *   cover: '',//站点封面
 *   language: '',//站点语言 zh: 中文；en：英文
 *   name_zh: '',//中文站点名称
 *   name_en: '',//英文站点名称
 *   wx_config: { //微信分享设置
 *      zh:{
 *        title:'',// 标题
 *        introduction:'',// 简介
 *        cover:'',// 图片
 *      },
 *      en:{
 *        title: '',//标题
 *        introduction:'',// 简介
 *        cover:'',// 图片
 *      }
 *   }
 * }
 * @param option
 */
export function vhSiteBaseInfoPostMessage(option = {}) {
  if (inIframe) {
    try {
      const message = {
        type: 'vhSiteBaseInfo',
        data: {
          ...option,
          business_id: Number(sessionStorage.getItem('initGrayId'))
        }
      };
      console.log('[message pipeline] vhSiteBaseInfoPostMessage data ', message);
      window.top.postMessage(message, '*');
    } catch (e) {
      console.error();
    }
  }
}
